export enum FeatureType {
    Line = 0,
    Point = 1,
    Polygon = 2,
    Raster = 3,
    Undefined = 4,
};